"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyTrue = exports.AllTrue = exports.PopulationVariance = exports.Variance = exports.PopulationStdDev = exports.GeometricMean = exports.Product = exports.StdDev = exports.Mode = exports.Median = exports.Avg = exports.Max = exports.Min = exports.Sum = exports.Count = void 0;
var expression_1 = require("./expression");
var util_1 = require("../util/util");
var datatypes_1 = require("../datatypes/datatypes");
var exception_1 = require("../datatypes/exception");
var comparison_1 = require("../util/comparison");
var builder_1 = require("./builder");
var AggregateExpression = /** @class */ (function (_super) {
    __extends(AggregateExpression, _super);
    function AggregateExpression(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        return _this;
    }
    return AggregateExpression;
}(expression_1.Expression));
var Count = /** @class */ (function (_super) {
    __extends(Count, _super);
    function Count(json) {
        return _super.call(this, json) || this;
    }
    Count.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if ((0, util_1.typeIsArray)(items)) {
            return (0, util_1.removeNulls)(items).length;
        }
        return 0;
    };
    return Count;
}(AggregateExpression));
exports.Count = Count;
var Sum = /** @class */ (function (_super) {
    __extends(Sum, _super);
    function Sum(json) {
        return _super.call(this, json) || this;
    }
    Sum.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        try {
            items = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        if (hasOnlyQuantities(items)) {
            var values = getValuesFromQuantities(items);
            var sum = values.reduce(function (x, y) { return x + y; });
            return new datatypes_1.Quantity(sum, items[0].unit);
        }
        else {
            return items.reduce(function (x, y) { return x + y; });
        }
    };
    return Sum;
}(AggregateExpression));
exports.Sum = Sum;
var Min = /** @class */ (function (_super) {
    __extends(Min, _super);
    function Min(json) {
        return _super.call(this, json) || this;
    }
    Min.prototype.exec = function (ctx) {
        var list = this.source.execute(ctx);
        if (list == null) {
            return null;
        }
        var listWithoutNulls = (0, util_1.removeNulls)(list);
        // Check for incompatible units and return null. We don't want to convert
        // the units for Min/Max, so we throw away the converted array if it succeeds
        try {
            processQuantities(list);
        }
        catch (e) {
            return null;
        }
        if (listWithoutNulls.length === 0) {
            return null;
        }
        // We assume the list is an array of all the same type.
        var minimum = listWithoutNulls[0];
        for (var _i = 0, listWithoutNulls_1 = listWithoutNulls; _i < listWithoutNulls_1.length; _i++) {
            var element = listWithoutNulls_1[_i];
            if ((0, comparison_1.lessThan)(element, minimum)) {
                minimum = element;
            }
        }
        return minimum;
    };
    return Min;
}(AggregateExpression));
exports.Min = Min;
var Max = /** @class */ (function (_super) {
    __extends(Max, _super);
    function Max(json) {
        return _super.call(this, json) || this;
    }
    Max.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (items == null) {
            return null;
        }
        var listWithoutNulls = (0, util_1.removeNulls)(items);
        // Check for incompatible units and return null. We don't want to convert
        // the units for Min/Max, so we throw away the converted array if it succeeds
        try {
            processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (listWithoutNulls.length === 0) {
            return null;
        }
        // We assume the list is an array of all the same type.
        var maximum = listWithoutNulls[0];
        for (var _i = 0, listWithoutNulls_2 = listWithoutNulls; _i < listWithoutNulls_2.length; _i++) {
            var element = listWithoutNulls_2[_i];
            if ((0, comparison_1.greaterThan)(element, maximum)) {
                maximum = element;
            }
        }
        return maximum;
    };
    return Max;
}(AggregateExpression));
exports.Max = Max;
var Avg = /** @class */ (function (_super) {
    __extends(Avg, _super);
    function Avg(json) {
        return _super.call(this, json) || this;
    }
    Avg.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        try {
            items = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        if (hasOnlyQuantities(items)) {
            var values = getValuesFromQuantities(items);
            var sum = values.reduce(function (x, y) { return x + y; });
            return new datatypes_1.Quantity(sum / values.length, items[0].unit);
        }
        else {
            var sum = items.reduce(function (x, y) { return x + y; });
            return sum / items.length;
        }
    };
    return Avg;
}(AggregateExpression));
exports.Avg = Avg;
var Median = /** @class */ (function (_super) {
    __extends(Median, _super);
    function Median(json) {
        return _super.call(this, json) || this;
    }
    Median.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        try {
            items = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (!hasOnlyQuantities(items)) {
            return medianOfNumbers(items);
        }
        var values = getValuesFromQuantities(items);
        var median = medianOfNumbers(values);
        return new datatypes_1.Quantity(median, items[0].unit);
    };
    return Median;
}(AggregateExpression));
exports.Median = Median;
var Mode = /** @class */ (function (_super) {
    __extends(Mode, _super);
    function Mode(json) {
        return _super.call(this, json) || this;
    }
    Mode.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        var filtered;
        try {
            filtered = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (hasOnlyQuantities(filtered)) {
            var values = getValuesFromQuantities(filtered);
            var mode = this.mode(values);
            if (mode.length === 1) {
                mode = mode[0];
            }
            return new datatypes_1.Quantity(mode, items[0].unit);
        }
        else {
            var mode = this.mode(filtered);
            if (mode.length === 1) {
                return mode[0];
            }
            else {
                return mode;
            }
        }
    };
    Mode.prototype.mode = function (arr) {
        var max = 0;
        var counts = {};
        var results = [];
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var elem = arr_1[_i];
            var cnt = (counts[elem] = (counts[elem] != null ? counts[elem] : 0) + 1);
            if (cnt === max && !results.includes(elem)) {
                results.push(elem);
            }
            else if (cnt > max) {
                results = [elem];
                max = cnt;
            }
        }
        return results;
    };
    return Mode;
}(AggregateExpression));
exports.Mode = Mode;
var StdDev = /** @class */ (function (_super) {
    __extends(StdDev, _super);
    function StdDev(json) {
        var _this = _super.call(this, json) || this;
        _this.type = 'standard_deviation';
        return _this;
    }
    StdDev.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        try {
            items = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        if (hasOnlyQuantities(items)) {
            var values = getValuesFromQuantities(items);
            var stdDev = this.standardDeviation(values);
            return new datatypes_1.Quantity(stdDev, items[0].unit);
        }
        else {
            return this.standardDeviation(items);
        }
    };
    StdDev.prototype.standardDeviation = function (list) {
        var val = this.stats(list);
        if (val) {
            return val[this.type];
        }
    };
    StdDev.prototype.stats = function (list) {
        var sum = list.reduce(function (x, y) { return x + y; });
        var mean = sum / list.length;
        var sumOfSquares = 0;
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var sq = list_1[_i];
            sumOfSquares += Math.pow(sq - mean, 2);
        }
        var std_var = (1 / (list.length - 1)) * sumOfSquares;
        var pop_var = (1 / list.length) * sumOfSquares;
        var std_dev = Math.sqrt(std_var);
        var pop_dev = Math.sqrt(pop_var);
        return {
            standard_variance: std_var,
            population_variance: pop_var,
            standard_deviation: std_dev,
            population_deviation: pop_dev
        };
    };
    return StdDev;
}(AggregateExpression));
exports.StdDev = StdDev;
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product(json) {
        return _super.call(this, json) || this;
    }
    Product.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        try {
            items = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        if (hasOnlyQuantities(items)) {
            var values = getValuesFromQuantities(items);
            var product = values.reduce(function (x, y) { return x * y; });
            // Units are not multiplied for the geometric product
            return new datatypes_1.Quantity(product, items[0].unit);
        }
        else {
            return items.reduce(function (x, y) { return x * y; });
        }
    };
    return Product;
}(AggregateExpression));
exports.Product = Product;
var GeometricMean = /** @class */ (function (_super) {
    __extends(GeometricMean, _super);
    function GeometricMean(json) {
        return _super.call(this, json) || this;
    }
    GeometricMean.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        if (!(0, util_1.typeIsArray)(items)) {
            return null;
        }
        try {
            items = processQuantities(items);
        }
        catch (e) {
            return null;
        }
        if (items.length === 0) {
            return null;
        }
        if (hasOnlyQuantities(items)) {
            var values = getValuesFromQuantities(items);
            var product = values.reduce(function (x, y) { return x * y; });
            var geoMean = Math.pow(product, 1.0 / items.length);
            return new datatypes_1.Quantity(geoMean, items[0].unit);
        }
        else {
            var product = items.reduce(function (x, y) { return x * y; });
            return Math.pow(product, 1.0 / items.length);
        }
    };
    return GeometricMean;
}(AggregateExpression));
exports.GeometricMean = GeometricMean;
var PopulationStdDev = /** @class */ (function (_super) {
    __extends(PopulationStdDev, _super);
    function PopulationStdDev(json) {
        var _this = _super.call(this, json) || this;
        _this.type = 'population_deviation';
        return _this;
    }
    return PopulationStdDev;
}(StdDev));
exports.PopulationStdDev = PopulationStdDev;
var Variance = /** @class */ (function (_super) {
    __extends(Variance, _super);
    function Variance(json) {
        var _this = _super.call(this, json) || this;
        _this.type = 'standard_variance';
        return _this;
    }
    return Variance;
}(StdDev));
exports.Variance = Variance;
var PopulationVariance = /** @class */ (function (_super) {
    __extends(PopulationVariance, _super);
    function PopulationVariance(json) {
        var _this = _super.call(this, json) || this;
        _this.type = 'population_variance';
        return _this;
    }
    return PopulationVariance;
}(StdDev));
exports.PopulationVariance = PopulationVariance;
var AllTrue = /** @class */ (function (_super) {
    __extends(AllTrue, _super);
    function AllTrue(json) {
        return _super.call(this, json) || this;
    }
    AllTrue.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        return (0, util_1.allTrue)((0, util_1.removeNulls)(items));
    };
    return AllTrue;
}(AggregateExpression));
exports.AllTrue = AllTrue;
var AnyTrue = /** @class */ (function (_super) {
    __extends(AnyTrue, _super);
    function AnyTrue(json) {
        return _super.call(this, json) || this;
    }
    AnyTrue.prototype.exec = function (ctx) {
        var items = this.source.execute(ctx);
        return (0, util_1.anyTrue)(items);
    };
    return AnyTrue;
}(AggregateExpression));
exports.AnyTrue = AnyTrue;
function processQuantities(values) {
    var items = (0, util_1.removeNulls)(values);
    if (hasOnlyQuantities(items)) {
        return convertAllUnits(items);
    }
    else if (hasSomeQuantities(items)) {
        throw new exception_1.Exception('Cannot perform aggregate operations on mixed values of Quantities and non Quantities');
    }
    else {
        return items;
    }
}
function getValuesFromQuantities(quantities) {
    return quantities.map(function (quantity) { return quantity.value; });
}
function hasOnlyQuantities(arr) {
    return arr.every(function (x) { return x.isQuantity; });
}
function hasSomeQuantities(arr) {
    return arr.some(function (x) { return x.isQuantity; });
}
function convertAllUnits(arr) {
    // convert all quantities in array to match the unit of the first item
    return arr.map(function (q) { return q.convertUnit(arr[0].unit); });
}
function medianOfNumbers(numbers) {
    var items = (0, util_1.numerical_sort)(numbers, 'asc');
    if (items.length % 2 === 1) {
        // Odd number of items
        return items[(items.length - 1) / 2];
    }
    else {
        // Even number of items
        return (items[items.length / 2 - 1] + items[items.length / 2]) / 2;
    }
}
//# sourceMappingURL=aggregate.js.map